"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFocus = exports.renderButton = exports.iconLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _ButtonAndCTAMethods = require("../../utils/methods/ButtonAndCTAMethods");
var _LunaLink = _interopRequireWildcard(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const renderFocus = (className, mouse) => {
  const formmatedClassName = className ? (0, _ButtonAndCTAMethods.formatClassName)(className) : null;
  if (formmatedClassName && mouse) {
    return `ter-button ${formmatedClassName}`;
  } else if (formmatedClassName && !mouse) {
    return `ter-button ${formmatedClassName} tabFocus`;
  } else if (!formmatedClassName && mouse === false) {
    return "ter-button ter-button--primary--1 tabFocus";
  } else {
    return "ter-button ter-button--primary--1";
  }
};
exports.renderFocus = renderFocus;
const externalIcon = color => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-diagnol"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    role: "img",
    "aria-label": "external link icon"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: "arrow",
    d: "M17,12a1,1,0,0,0-1,1v5H2V4H7A1,1,0,0,0,7,2H1A1,1,0,0,0,0,3V19a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V13A1,1,0,0,0,17,12Z",
    fill: color || "#252A2E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "arrow",
    d: "M19,0H12a1,1,0,0,0,0,2h4.59l-8.3,8.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L18,3.41V8a1,1,0,0,0,2,0V1A1,1,0,0,0,19,0Z",
    fill: color || "#252A2E"
  })));
};
const internalIcon = color => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-diagnol"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    role: "img",
    "aria-label": "internal link icon"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: "arrow",
    d: "M19,0H1A1,1,0,0,0,0,1V19a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V1A1,1,0,0,0,19,0ZM18,18H2V2H18Z",
    fill: color || "#252A2E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "arrow",
    d: "M5,11h7.59L9.34,14.24a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-4.95a1,1,0,0,0,0-1.42l-5-4.95A1,1,0,0,0,9.34,5.76L12.59,9H5a1,1,0,0,0,0,2Z",
    fill: color || "#252A2E"
  })))));
};
const icons = [externalIcon, internalIcon];
const iconLink = (color, icon) => {
  return icon(color);
};
exports.iconLink = iconLink;
const renderColorForIcon = className => {
  if (!className) {
    return "#ffffff";
  }
  if (className.includes("primary--1") || className.includes("secondary--2")) {
    return "#ffffff";
  } else if (className.includes("primary--2") || className.includes("secondary--1")) {
    return "#0063A3";
  } else if (className.includes("--alt")) {
    return "#26292E";
  } else {
    return "#ffffff";
  }
};
const renderButton = props => {
  const {
    contentfulId,
    onClick,
    className,
    text,
    name,
    url,
    id,
    children,
    Link,
    size = "lg",
    video,
    setOverride,
    override,
    VideoComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    setVideoProgress,
    videoProgress,
    disabled,
    inlineStyle,
    englishTextLabel
  } = props;
  const {
    mouse
  } = (0, _useMouse.default)();
  // to link to external site in Gatsby, http/https is required. Using www to start a url will cause a Gatsby site to link to an internal page incorrectly // example - url of "www.trimble.com" will go to "https://www.Lauras-Gatsby-Site.com/www.trimble.com" instead of linking out externally.

  const formatSize = {
    lg: "48px",
    md: "36px",
    sm: "32px"
  };
  if (video) {
    video["videoProgress"] = videoProgress;
    video["setVideoProgress"] = setVideoProgress;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
      "data-sb-object-id": contentfulId ? contentfulId : null,
      "data-english-text-label": englishTextLabel,
      className: className ? renderFocus(className, mouse) : renderFocus(null, mouse),
      onClick: () => {
        setOverride(true);
      },
      style: {
        ...inlineStyle
      }
    }, text || children, " ", iconLink(renderColorForIcon(className), icons[0])), override && VideoComponent && /*#__PURE__*/_react.default.createElement(VideoComponent, {
      setOverride: setOverride,
      override: override,
      content: video,
      videoProgress: videoProgress,
      setVideoProgress: setVideoProgress
    }));
  }
  let buttonIcon = (0, _LunaLink.checkForExternalLink)(url) ? icons[0] : icons[1];
  if (url) {
    return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      contentfulId: contentfulId ? contentfulId : null,
      "aria-label": `link to ${text}`,
      className: renderFocus(className, mouse),
      rel: (0, _LunaLink.checkForExternalLink)(url) ? "noopener" : null,
      to: url,
      Link: Link && Link,
      style: {
        textDecoration: "none",
        height: `${formatSize[size]}` || "48px",
        ...inlineStyle
      },
      onClick: onClick ? onClick : null,
      englishTextLabel: englishTextLabel
    }, text || children, " ", iconLink(renderColorForIcon(className), buttonIcon));
  } else {
    return /*#__PURE__*/_react.default.createElement("button", {
      onClick: onClick ? onClick : null,
      className: renderFocus(className, mouse),
      name: name,
      disabled: disabled,
      style: {
        height: `${formatSize[size]}` || "48px",
        ...inlineStyle
      },
      "data-sb-object-id": contentfulId ? contentfulId : null,
      "data-english-text-label": englishTextLabel
    }, text || children);
  }
};
exports.renderButton = renderButton;